import styled from "@emotion/styled";

export const CancelContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 20px;
`;

export const TitleContainer = styled.div`
  display: flex;
  padding-bottom: 20px;
  align-items: center;
  border-bottom: 1px solid var(--color-line-normal, #e4e5e7);
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const InfoBox = styled.div`
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  border-radius: 8px;
  background-color: var(--global-color-blue-98);
`;

export const Divider = styled.div`
  height: 1px;
  align-self: stretch;
  width: 100%;
  background-color: var(--alias-color-line-normal);
`;

export const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
